import PromotionsCRUDActions from '../actions/PromotionsCRUDActions';
import companyCRUDActions from '../actions/CompanyCRUDActions';

import commonHandler from './common-handler';

const CHROME_ERROR = 'Unexpected end of JSON input';
const FIREFOX_ERROR = 'unexpected end of data';

export default dispatch => async error => {
  if (error.message === CHROME_ERROR
    || (error.message && error.message.indexOf(FIREFOX_ERROR) > -1)
  ) {
    dispatch({
      type: PromotionsCRUDActions.setStatus,
      isStatusValid: true,
    });
    dispatch(companyCRUDActions.retrieveAll());
    return;
  }
  switch (error.status) {
    case 404:
      dispatch({
        type: PromotionsCRUDActions.setStatus,
        isStatusValid: false,
      });
      break;
    default:
      commonHandler(dispatch)(error);
  }
};
